import { useCallback, useState } from "react";
import {
  getRankingCommuneByRestoId,
  getRankingGlobalByRestoId,
  getRankingLocalByRestoId,
  getRankingRegionalByRestoId,
} from "../services/rankingService";

export const OWNER_RANKING_TYPE = {
  GLOBAL: "global",
  LOCAL: "local",
  COMMUNE: "commune",
  REGION: "region",
};

const OWNER_RANKING_REQUESTS = {
  [OWNER_RANKING_TYPE.GLOBAL]: getRankingGlobalByRestoId,
  [OWNER_RANKING_TYPE.LOCAL]: getRankingLocalByRestoId,
  [OWNER_RANKING_TYPE.COMMUNE]: getRankingCommuneByRestoId,
  [OWNER_RANKING_TYPE.REGION]: getRankingRegionalByRestoId,
};

const normalizeRankingType = (rankingType) =>
  OWNER_RANKING_REQUESTS[rankingType] ? rankingType : OWNER_RANKING_TYPE.GLOBAL;

export const useOwnerRanking = () => {
  const [rankingData, setRankingData] = useState({ ranking: [], total: 0, pos: 0 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const runRequest = useCallback(async (request) => {
    setLoading(true);
    setError(null);
    try {
      const response = await request();
      const payload = response || { ranking: [], total: 0, pos: 0 };
      setRankingData({
        ranking: Array.isArray(payload?.ranking) ? payload.ranking : [],
        total: Number(payload?.total || 0),
        pos: Number(payload?.pos || 0),
      });
      return payload;
    } catch (err) {
      setError(err?.message || "Error al cargar ranking.");
      setRankingData({ ranking: [], total: 0, pos: 0 });
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const getRanking = useCallback((restoId, rankingType = OWNER_RANKING_TYPE.GLOBAL) => {
    if (!restoId) {
      setRankingData({ ranking: [], total: 0, pos: 0 });
      setError(null);
      return Promise.resolve(null);
    }

    const normalizedRankingType = normalizeRankingType(rankingType);
    return runRequest(() => OWNER_RANKING_REQUESTS[normalizedRankingType](restoId));
  }, [runRequest]);

  const getLocalRanking = useCallback((restoId) => getRanking(restoId, OWNER_RANKING_TYPE.LOCAL), [getRanking]);

  return {
    rankingData,
    loading,
    error,
    getRanking,
    getLocalRanking,
  };
};
